//LP Announcement Bar Timer Start
function initializeTimer(timerElement, initialTime) {
	var timeRemaining = initialTime;

	function updateTimer() {
		var minutes = Math.floor(timeRemaining / 60);
		var seconds = timeRemaining % 60;
		var formattedTime = ('0' + minutes).slice(-2) + ':' + ('0' + seconds).slice(-2);

		timerElement.textContent = formattedTime;

		if (timeRemaining <= 0) {
			clearInterval(timerInterval);
		} else {
			timeRemaining--;
		}
	}

	var timerInterval = setInterval(updateTimer, 1000);
}

var offerTimers = document.querySelectorAll('.wls-promo-bar__offer-timer');

offerTimers.forEach(function (timer) {
	initializeTimer(timer, 60 * 60);
});
//LP Announcement Bar Timer End


$(document).ready(function() { 
  var grid = new Isotope('.clinical-studies-list', {
    itemSelector: '.clinical-studies-block',
    layoutMode: 'fitRows',
    stagger: 30
  });
  
  $('.clinical-studies-filter button').on('click', function() {
    var filterValue = $(this).attr('data-filter');
    grid.arrange({ filter: filterValue });
    
    $('.clinical-studies-filter button').removeClass('active');
    $(this).addClass('active');
  });
  
  //Mobile Menu
  $("li.hasSubmenu").click(function(){
    $(this).find('ul.submenu').slideToggle();
    $(this).toggleClass("open");
  });
  
  //Global Fancybox YT Video
  Fancybox.bind('[data-fancybox]', {
      Html : {
        youtube: {
          controls: 0,
          rel: 0,
          fs: 0
        }
      }
    });    
  
    //Video Gallery Slider
    $('.video-slider').slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      prevArrow: '<button type="button" class="slick-prev slick-arrow"> <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M12.6663 8H3.33301" stroke="#847A78" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M7.99967 12.6667L3.33301 8.00004L7.99967 3.33337" stroke="#847A78" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg> </button>',
      nextArrow: '<button type="button" class="slick-next slick-arrow"> <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M3.33366 8H12.667" stroke="#847A78" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M8.00033 12.6667L12.667 8.00004L8.00033 3.33337" stroke="#847A78" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg> </button>',
      responsive: [
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    });
  
    $('.diffrence-section').slick({
      infinite: true,
      arrows: true,
      dots:true,
      prevArrow: '<button class="slick-arrow slick-prev"><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"> <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"> </path></svg></button>',
      nextArrow: '<button class="slick-arrow slick-next"><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"> <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"> </path></svg></button>',
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
          }
        }
      ]
    });

    // Tabbing section
    $('.review-tab-section .tab-link a').click(function(e) {
        e.preventDefault();
        const tabId = $(this).data('tab');

        // Hide all tab contents and remove active class
        $('.review-tab-section .tab-content').removeClass('active').hide();

        // Show the clicked tab's content and add active class
        $('#' + tabId).addClass('active').show();

        // Remove active class from all tab links and their parents
        $('.review-tab-section .tab-link').removeClass('active');
        $('.review-tab-section .tab-link a').removeClass('active');

        // Add active class to the clicked tab link and its parent
        $(this).addClass('active');
        $(this).parent('.review-tab-section .tab-link').addClass('active');
    });

    // Open the first tab by default
    $('.review-tab-section .tab-link a').first().click();

    //PDP Skin Section tab
    $(".skin-section .skin-tab-title a").click(function(event){
        event.preventDefault();
        var tabid = $(this).attr("href");
        console.log(tabid);
        $(this).closest("li").addClass("active").siblings().removeClass("active");
        $(".skin-wrap .skin-tab-content").hide();
        $(tabid).show();
    });

  //PDP Faq
  $(".accordian li h6").click(function(){
    $(this).closest("li").toggleClass("active").siblings().removeClass("active");
    $(this).closest("li").siblings().find(".content").hide();
    $(this).next(".content").toggle();
  });

  //How it works Video Slider
  $('.videos-wrap').slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      prevArrow: '<button type="button" class="slick-prev slick-arrow"> <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M12.6663 8H3.33301" stroke="#847A78" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M7.99967 12.6667L3.33301 8.00004L7.99967 3.33337" stroke="#847A78" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg> </button>',
      nextArrow: '<button type="button" class="slick-next slick-arrow"> <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M3.33366 8H12.667" stroke="#847A78" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M8.00033 12.6667L12.667 8.00004L8.00033 3.33337" stroke="#847A78" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg> </button>',
      responsive: [
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 2,
            arrows: true,
            infinite: true,
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            arrows: true,
            infinite: true,
          }
        }
      ]
  });
  var $atcButton = $('.product.grid .product__info-wrapper .product-form__buttons'); // Add to Cart button selector
  var $stickyBar = $('.sticky-atc'); // Sticky bar selector
  
  // Function to check if ATC button is out of view
  function checkATCButton() {
      if ($atcButton.length) { // Check if element exists
          var atcPosition = $atcButton[0].getBoundingClientRect().top;
          console.log(atcPosition);
          var windowHeight = $(window).height();
  
          if (atcPosition < -$atcButton.outerHeight()) { // Check if the ATC button is completely out of the viewport
              if (window.innerWidth <= 749) {
                  $stickyBar.css('bottom', "0");
                  // $stickyBar.removeClass('show-cta');
              } else {
                  $stickyBar.addClass('show-cta');
                  $stickyBar.css('bottom', "24px");
              }
          } else {
              // ATC button is still in view or partially in view
              $stickyBar.removeClass('show-cta');
              $stickyBar.css('bottom', "-100%");
          }
      }
  }
  
  // Check ATC button on scroll and resize
  $(window).on('scroll resize', function() {
      checkATCButton();
  });
  
  // Initial check on page load
  checkATCButton();


});

// $(document).ready(function() {
//   console.log('run');
//     if($('.product .product__media-wrapper button.deferred-media__poster').length > 0){
//       $(".product .product__media-wrapper button.deferred-media__poster").click();
//       $(".product .product__media-wrapper button.deferred-media__poster video").on("loadeddata", function() {
//           var video =  $(" .product .product__media-wrapper button.deferred-media__poster video").get(0);
//           video.play();
//       });
//     }
// });


$(window).on("load resize", function(){
  //Announceent Bar Sticky
  var announcementHeight = $(".utility-bar").outerHeight();
  var headerHeight = $("header").outerHeight();
  var stickyBar = $('.sticky-atc'); // Sticky bar selector
  $(".shopify-section-header-sticky").css("top", announcementHeight);
  $("html").css("padding-top", announcementHeight + headerHeight);
  // stickyBar.removeClass('show-cta');
  
  //Sticky Bar padding for mobile
  if ($(window).width() < 750) {
      var stickyBarHeight = $('.sticky-atc').outerHeight();
      if (stickyBarHeight > 0) {
          $('footer').css('margin-bottom', stickyBarHeight + 'px');
          // stickyBar.addClass('show-cta');
      }
  } else {
      $('footer').css('margin-bottom', '0');
      // stickyBar.removeClass('show-cta');
  }
});



//Autoplay video


// luxe-pro-shaver page
// shvaer kit popup on mobile ...
function toggleAccordion(element) {
    let accordions = document.querySelectorAll(".accordion");
    let isMobile = window.innerWidth <= 768; // Check if it's mobile view

    // Loop through all accordion items
    accordions.forEach(acc => {
        if (acc !== element) {
            acc.classList.remove("active");
            let popup = acc.querySelector(".popup-wrapper");
            if (popup) {
                popup.classList.remove("open"); // Close other popups in mobile
                document.body.style.overflow = ""; // Restore scrolling when closing popup
            }
        }
    });

    // Toggle the 'active' class on the clicked accordion
    element.classList.toggle("active");

    // Handle mobile popup
    if (isMobile) {
        let popup = element.querySelector(".popup-wrapper");
        if (popup) {
            popup.classList.toggle("open");
            // Prevent scrolling when popup is open
            document.body.style.overflow = popup.classList.contains("open") ? "hidden" : "";
        }
    }
}

// Close popup when clicking outside or on close button
document.addEventListener("click", function (event) {
    let popups = document.querySelectorAll(".popup-wrapper.open");
    popups.forEach(popup => {
        if (!popup.closest(".accordion").contains(event.target) || event.target.closest(".icon-close")) {
            popup.classList.remove("open");
            popup.closest(".accordion").classList.remove("active");
            document.body.style.overflow = ""; // Restore scrolling when closing popup
        }
    });
});

// feedback slider
$('.feedback-section .feedback-slider').slick({
  arrows: true,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  draggable: true,
  swipe: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        infinite: true,
        slidesToShow: 3,
         arrow: true,
        slidesToScroll: 1,
        
      }
    },
    {
      breakpoint: 768,
      settings: {
         dots: false,
        slidesToShow: 2,
        slidesToScroll: 1,
         arrow: true,
         dots: true,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1, 
        // centerMode: true,
        // centerPadding: '40px',
        dots: true,
        arrow: true,
      }
    }
   
  ]
});


// FAQ
const accordionsHolders = document.querySelectorAll(
  ".wls-js-accordions"
);
if (accordionsHolders && !!accordionsHolders.length) {
  accordionsHolders.forEach((holder) => {
    const accordions = holder.querySelectorAll(
      ".wls-accordion"
    );

    accordions[0].classList.remove("show-text");

    accordions.forEach((accordion) => {
      const accordionBtn = accordion.querySelector(
        ".wls-accordion__header"
      );
      const panel = accordion.querySelector(".wls-accordion__panel");
      accordionBtn.addEventListener("click", () => {
        accordion.classList.toggle("show-text");
        panel.style.maxHeight = panel.scrollHeight + "px";
        !accordion.classList.contains("show-text")
          ? (panel.style.maxHeight = null)
          : (panel.style.maxHeight = panel.scrollHeight + 40 + "px");
      });
    });
  });
}
// END FAQ

// comparison table slider for mobile only (disabled when ≤3 columns)
$(document).ready(function () {
  function initSlickForMobile() {
    var $table = $('.wls-comparison-table.fb-table');
    var $slider = $table.find('.comparison-table-slider-mobile');
    if (!$slider.length) return;

    var enableSlider = $(window).width() <= 767 && !$table.hasClass('no-mobile-slider');

    if (enableSlider) {
      if (!$slider.hasClass('slick-initialized')) {
        $slider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: true,
          infinite: false,
        });
      }
    } else if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
  }

  initSlickForMobile();

  $(window).resize(function () {
    initSlickForMobile();
  });
});

// HOW IT WORKS
// $(document).ready(function () {

//     var sliderInit = false;

//     function initSlider() {
//         if (window.innerWidth <= 1024) {
//             if (!sliderInit) {
//                 $('.wls-how-it-works__steps').slick({
//                     slidesToShow: 2,
//                     slidesToScroll: 1,
//                     dots: true,
//                     prevArrow: '.wls-how-it-works__prev',
//                     nextArrow: '.wls-how-it-works__next',
//                     responsive: [
//                         {
//                             breakpoint: 768,
//                             settings: {
//                                 slidesToShow: 1
//                             }
//                         }
//                     ]
//                 });
//                 sliderInit = true;

//                 // Arrow click → pause video
//                 $('.wls-how-it-works__prev, .wls-how-it-works__next').on('click', function () {
//                     var slider = $('.wls-how-it-works__steps');
//                     var currentSlide = slider.slick('slickCurrentSlide');
//                     var currentVideo = $('.wls-how-it-works__step')
//                         .eq(currentSlide)
//                         .find('.wls-how-it-works__step-video video')[0];

//                     if (currentVideo && !currentVideo.paused) {
//                         currentVideo.pause();
//                     }
//                 });
//             }
//         } else {
//             if (sliderInit) {
//                 $('.wls-how-it-works__steps').slick('unslick');
//                 sliderInit = false;
//             }
//         }
//     }

//     // Initial load
//     initSlider();

//     // On resize
//     $(window).on('resize', function () {
//         initSlider();
//     });
// });








